import { Outlet } from "react-router-dom";
import { AppSidebar } from "@/components/AppSidebar";
import { SidebarProvider, SidebarTrigger, SidebarInset } from "@/components/ui/sidebar";
import { FeedbackButton } from "@/components/feedback/FeedbackButton";
import { ContactModalProvider } from "@/components/contacts/ContactModalProvider";

export function Layout() {
  return (
    <ContactModalProvider>
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset>
          <header className="flex h-12 shrink-0 items-center gap-2 border-b px-4">
            <SidebarTrigger className="-ml-1" />
          </header>
          <main className="flex-1 overflow-auto animate-fade-in">
            <Outlet />
          </main>
        </SidebarInset>
        <FeedbackButton />
      </SidebarProvider>
    </ContactModalProvider>
  );
}
